import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Tupian"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M8.8015 11.386L6.6425 8.863C6.3015 8.4645 5.6805 8.4005 5.256 8.718C5.19941 8.76079 5.14746 8.80939 5.101 8.863L1.923 12.577H13.769L11.597 9.87C11.2705 9.462 10.651 9.38 10.215 9.685C10.1408 9.73725 10.0742 9.79951 10.017 9.87L8.802 11.386H8.8015ZM1.923 1.5H14.077C14.586 1.5 15 1.9125 15 2.423V13.5C15 13.6212 14.9761 13.7412 14.9297 13.8532C14.8834 13.9652 14.8154 14.067 14.7297 14.1527C14.644 14.2384 14.5422 14.3064 14.4302 14.3527C14.3182 14.3991 14.1982 14.423 14.077 14.423H1.923C1.67821 14.423 1.44344 14.3258 1.27034 14.1527C1.09724 13.9796 1 13.7448 1 13.5V2.423C1 1.914 1.414 1.5 1.923 1.5ZM11.308 7.0385C11.5505 7.0385 11.7905 6.99075 12.0145 6.89796C12.2385 6.80518 12.4421 6.66919 12.6135 6.49775C12.7849 6.32631 12.9209 6.12278 13.0137 5.89878C13.1065 5.67478 13.1543 5.4347 13.1543 5.19225C13.1543 4.9498 13.1065 4.70972 13.0137 4.48572C12.9209 4.26172 12.7849 4.05819 12.6135 3.88675C12.4421 3.71531 12.2385 3.57932 12.0145 3.48654C11.7905 3.39375 11.5505 3.346 11.308 3.346C10.8183 3.346 10.3487 3.54052 10.0025 3.88675C9.65627 4.23299 9.46175 4.70259 9.46175 5.19225C9.46175 5.68191 9.65627 6.15151 10.0025 6.49775C10.3487 6.84399 10.8183 7.0385 11.308 7.0385Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var tupian = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { tupian as default };
